import { Inject, Injectable } from '@angular/core';
import { ProductPriceLog, ProductPriceLogRepository } from '@infrab4a/connect';
import { ConnectRequest } from 'src/app/models';
import { BaseConnectService } from './base-connect.service';

@Injectable({
  providedIn: 'root'
})
export class ShopProductPriceLogService extends BaseConnectService<ProductPriceLog> {
  constructor(
    @Inject('ProductPriceLogRepository')
    readonly productPriceLogRepository: ProductPriceLogRepository
  ) {
    super(productPriceLogRepository);
  }

  async getPaginatedList(request: Partial<ConnectRequest>) {
    const result = await this.paginatedSearch(request);
    const content = result.data.map((log) => ({ ...log }));
    const totalPages = request.pageSize
      ? Math.floor(result.count / request.pageSize)
      : undefined;
    const totalElements = result.count;

    return {
      totalPages,
      totalElements,
      content,
      empty: result.count === 0
    };
  }
}
